module.exports = __webpack_public_path__ + "img/supercomp.9808158e.svg";